const riot = require('riot');

riot.tag2('module-note-header', '<div class="border-bottom pb12"> <div class="f fm fbw mb8"> <div class="f fm"> <div class="mr12" data-is="atom-project" item="{note.getProject()}"></div> <div class="cursor-pointer max-width-100 mr12" data-is="atom-status" note="{note}" enable-next="{true}"></div> <div data-is="atom-assign" note="{note}"></div> </div> <div class="f fm"><i class="fs20 cursor-pointer mr8 tooltip {note.isFavorite() ? &quot;icon-fill_favorite&quot; : &quot;icon-favorite text-label_dark_medium&quot;}" onclick="{toggleFavorite}" aria-label="お気に入り" data-tooltip-position="top"></i><i class="fs20 cursor-pointer mr8 tooltip {note.isPinned() ? &quot;icon-fill_pin text-background_dark_primary&quot; : &quot;icon-pin text-label_dark_medium&quot;}" onclick="{togglePin}" aria-label="ピン留め" data-tooltip-position="top"></i><i class="icon-copy fs20 text-label_dark_medium cursor-pointer mr8 tooltip" onclick="{copyUrl}" aria-label="リンクをコピー" data-tooltip-position="top"></i> <div class="f fm cursor-pointer mr8 text-label_dark_medium tooltip" if="{note &amp;&amp; note.data.child_note_refs?.length &gt; 0}" onclick="{openChildNotesModal}" aria-label="子タスクを表示" data-tooltip-position="top"><i class="icon-remind fs20"></i> <div class="fs12 lh15 ml2">{note.data.child_note_refs.length}</div> </div><i class="icon-template fs20 text-label_dark_medium cursor-pointer mr8 tooltip" if="{note &amp;&amp; note.data.tags &amp;&amp; note.data.tags.includes(&quot;slide&quot;)}" onclick="{openSlide}" aria-label="スライド表示" data-tooltip-position="top"></i><i class="icon-more_horizontal text-label_dark_medium fs20 cursor-pointer tooltip" onclick="{onOpenActionSheet}" aria-label="メニュー" data-tooltip-position="top"></i> </div> </div> <div class="f fm flex-between"> <div class="f fm"><a class="f fm text-label_dark_primary mr12 tooltip" href="/{note.path}/messages" aria-label="メッセージへ"><i class="icon-comment fs16 mr4"></i> <div class="fs12 lh15">{note.data.message_count}</div></a> <div class="f fm text-label_dark_medium cursor-pointer" onclick="{openScheduleModal}"><i class="icon-time fs16 mr4 tooltip" aria-label="期限を設定"></i> <div class="fs11 lh15 mr4" if="{!note.data.end_at}">期限</div> <div class="fs12 lh15 {\'text-alert_primary\' : dayjs(note.data.end_at).isBefore(dayjs(),\'date\')}"> <time if="{note.data.end_at !== note.data.start_at}">{dayjs(note.data.start_at).format(⁗MM/DD(ddd)⁗)}</time> <time if="{note.data.end_at}">〜{dayjs(note.data.end_at).format(⁗MM/DD(ddd)⁗)}</time> </div> </div> </div> <div class="f fm"> <div class="mr12 s-mr8" if="{note}" data-is="atom-task-progress" content="{note.data.content}"></div> <div class="f fm cursor-pointer mr4" onclick="{() =&gt; {this.openHistories(true)}}"><img class="s20 circle flex-fixed object-fit-cover mr6" riot-src="{app.utils.getImageUrl(lastUpdatedUserIcon)}"> <div class="w-full"> <div class="text-label_dark_medium fs11 lh15">{dayjs(lastUpdatedAt).fromNow()}に更新</div> </div> </div> <div class="f fm ml16" if="{opts.showArrowButton}"><i class="icon-arrow-left cursor-pointer fs16 text-label_dark_primary p1 mr8 tooltip" aria-label="前へ" data-type="left" onclick="{onArrowClick}"></i><i class="icon-arrow-right cursor-pointer fs16 text-label_dark_primary p1 tooltip" aria-label="次へ" data-type="right" onclick="{onArrowClick}"></i></div> </div> </div> </div>', 'module-note-header,[data-is="module-note-header"]{display:block}', '', function(opts) {
    this.setNote = (note) => {
      this.note = note;
      this.fetchHistories();
      this.update();
    };

    this.togglePin = () => {
      return this.note.togglePin();
    };

    this.toggleFavorite = () => {
      return this.note.toggleFavorite();
    };

    this.onOpenActionSheet = (e) => {
      let options = [
        { label: 'ノートの編集履歴を表示', icon: 'time', action: () => { popup.close(); this.openHistories(); }},
        { label: 'ノートをクリップする', icon: 'clip', action: () => { popup.close(); this.clipNote(); }},
        { label: 'ノート単体ページを開く', icon: 'copy', action: () => { popup.close(); this.openNotePage(); }},
        { label: 'ノートのリンクをコピー', icon: 'copy', action: () => { popup.close(); this.copyUrl(); } },
        { label: 'タイトルとリンクをコピー', icon: 'copy', tooltip:'マークダウン書式でタイトルにリンクを挿入した形式でコピーします。', action: () => { popup.close(); this.copyTitleAndLink({url: `${location.origin}/${this.note.path}`, title: this.note.getTitle() }); } },
        { label: '子タスクを表示', icon: 'remind', action: () => { popup.close(); this.openChildNotesModal(); } },
        { label: 'スライド表示', icon: 'template', action: () => { popup.close(); this.openSlide(); } },
        { label: 'PDFを保存', icon: 'template', action: () => { popup.close(); this.previewPdf(); } },
        { label: 'ノートを複製', icon: 'template', action: () => { popup.close(); this.cloneNote(); } },
        { label: '関連ノートを作成', icon: 'add_circle', action: () => { popup.close(); this.onOpenModalReferredNote(); } },
        { label: 'ノートを移動', icon: 'move', action: () => { popup.close(); this.moveNote(); } },
        { label: 'ノートを削除', icon: 'stash_box', action: () => { popup.close(); this.deleteNote(); }, accent: true },
      ];

      const popup = spat.popup.open('popup-action-sheet', {
        element: e.currentTarget,
        closeTarget: e.currentTarget,
        offsetTop: 4,
        position: 'bottom',
        opts: {
          note: this.note,
          options: options,
        },
      });
    };

    this.showLatestComment = () => {

      spat.modal.alert('未実装');
    };

    this.openScheduleModal = async () => {
      if (!this.note) return ;
      let modal = spat.modal.open('modal-calendar', {note: this.note});

      await modal.waitClose();

      await this.note.refresh();
      this.update();
    };

    this.openHistories = (isDiff = false) => {
      spat.modal.open('modal-note-histories', {
        note: this.note,
        isDiff,
      });
    };

    this.copyUrl = () => {
      const url = `${location.origin}/${this.note.path}`;
      app.utils.copyToClipBoard(url);

      app.utils.openToast('copy');
    };

    this.copyTitleAndLink = ({ url, title }) => {
      let text = app.utils.getInsertLinkToTitle({ url, title });
      app.utils.copyToClipBoard(text);
      app.utils.openToast('copy');
    };

    this.onOpenModalReferredNote = async () => {
      let promises = [
        this.note.getProject().fetch(),
      ];
      let [project] = await Promise.all(promises);
      spat.modal.open('modal-referred-note', {project, note: this.note});
    };

    this.deleteNote = async () => {

      let result = await spat.modal.confirm('このノートを完全に削除しますか？\nこの操作を行うと元に戻せません。', '', {
        positive: '削除',
      });
      if (!result) return;

      await this.note.delete();

      spat.toast.message('ノートを削除しました。', {icon:'stash_box'});

      history.back();
    };

    this.moveNote = () => {
      let modal = spat.modal.open('modal-note-move', {notes: [this.note]});
      modal.on('move', (item) => {

        spat.router.push(`/${item.notes[0].path}`);
      });
    };

    this.previewPdf = () => {
      window.open(`/${this.note.path}/print`);
    };

    this.openNotePage = () => {
      window.open(`/${this.note.path}`);
    };

    this.cloneNote = () => {
      this.note.clone();
      app.utils.openToast('clone');
    };

    this.onArrowClick = (e) => {
      this.trigger('arrowclick', {
        type: e.currentTarget.dataset.type,
      });
    };

    this.clipNote = () => {
      app.utils.clip.clipNote(app.store.workspace.id, this.note);
      app.utils.openToast('clip');
    };

    this.fetchHistories = async () => {
      let histories = await this.note.fetchHistories();
      this.lastUpdatedUserIcon = histories[0]?.relation.user.data.icon_image || this.note.relation.updated_user.data.icon_image;
      this.lastUpdatedAt = histories[0]?.data.updated_at || this.note.data.updated_at;
      this.update();
    };

    this.openSlide = () => {
      if (!this.note) return;
      window.open(`/${this.note.path}/slide`);
    };

    this.openChildNotesModal = () => {
      spat.modal.open('modal-child-notes', {
        note: this.note,
      });
    };
});